import { useEffect, useRef } from 'react';

const useEffectOnce = (cb, isReady = true) => {
  const didRun = useRef(false);
  const result = useRef();

  useEffect(() => {
    if (!didRun.current && isReady) {
      didRun.current = true;
      result.current = cb();
    }

    return result.current;
  }, [isReady, cb]);
};

export default useEffectOnce;
